<template>
    <div class="final-practice" v-if="!showEmptyState">
        <div class="back-route" @click.stop="router.go(-1)"><i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>
        <h2>{{ $t('course.tree.PRACTICE') }}</h2>
        <div class="content-container">

        </div>

        <Modal :isOpen="modalPreview" @close="modalPreview = false">
            <div class="finalPractice__modal">
                <div class="finalPractice__modal_views">
                    <button 
                        @click="modalView = 1" 
                        :class="`finalPractice__modal_view${modalView === 1 ? '--active' : ''}`"
                    >
                        {{$t('finalPractice.TEACHER_TITLE')}}
                    </button>
                    <button 
                        @click="modalView = 2" 
                        :class="`finalPractice__modal_view${modalView === 2 ? '--active' : ''}`"
                        v-if="!modalPreview.hideSharedTab"
                    >
                        {{$t('finalPractice.STUDENT_TITLE')}}
                    </button>
                </div>
                <section class="finalPractice__modal_iframe">
                    <p class="finalPractice__modal_iframe__disclaimer" v-if="modalView === 1">{{$t('finalPractice.TEACHER_DISCLAIMER')}}</p>
                    <p class="finalPractice__modal_iframe__disclaimer" v-if="modalView === 2">{{$t('finalPractice.STUDENT_DISCLAIMER')}}</p>
                    <div v-html="modalView === 1 ? modalPreview.OwnTab : modalPreview.SharedTab"></div>
                </section>
                
                <div class="finalPractice__modal__buttons">
                    <button @click="modalPreview = false" class="finalPractice__modal_button">Cancelar</button>
                    <button 
                        @click="confirmModal = true" 
                        class="finalPractice__modal_button"
                        :disabled="user.role.toLowerCase() !== 'learninguser' || modalPreview.isSelected"
                    >
                        Continuar <i class="material-icons-outlined">arrow_forward</i>
                    </button>
                </div>
            </div>
        </Modal>

        <Modal :isOpen="confirmModal" @close="confirmModal = false">
            <div class="confirmModal">
                <h4 class="confirmModal__title">
                    ¿Deseas seleccionar la actividad?
                </h4>
                <p class="confirmModal__description">
                    Una vez confirmada la actividad no podrá ser modificada.
                </p>
                <div class="confirmModal__buttons">
                    <button @click="confirmModal = false" class="confirmModal__cancel">Cancelar</button>
                    <button :disabled="selectingContent" @click="selectOption()" class="confirmModal__confirm">Seleccionar</button>
                </div>
            </div>
        </Modal>

        <div v-if="user.permissions.includes('CURSO_REPORTES')" class="tutor-download-excel">
            <button :disabled="downloadingExcel" @click.stop="downloadExcel()">Descargar Reporte</button>
        </div>      
    </div>
    <EmptyState v-else icon="event_note" title="La práctica aún no está disponible" message="Podrás ver el contenido cuando tu facilitador habilite la práctica."/>

</template>

<script>
import { onMounted, ref, computed } from 'vue-demi';
import { useStore } from 'vuex';
import { useRouter,useRoute } from 'vue-router';
import EmptyState from '@/components/EmptyState.vue'
import Modal from '../components/Modal.vue';

export default {
    components: {
    EmptyState,
    Modal
},
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const user = computed(() => store.getters.manageUser_user);
        const moduleData = ref()
        const moduleDataLoaded = ref(false)
        const showEmptyState = ref(false);
        const renderContentTypes = ['HTML','FORUM','ATTACH','TRIP', 'CONTENTSHARE'];
        let container;
        const downloadingExcel = ref(false);
        const contentShare = ref([])
        const modalPreview = ref(undefined)
        const modalView = ref(1)
        const confirmModal = ref()
        const selectingContent = ref()

        const selectOption = async () => {
            if(selectingContent.value) return
            try {
                selectingContent.value = true
                let body = {
                    subcontentIdentifier: modalPreview.value.Identifier,
                    contentId: modalPreview.value.contentId
                }
                await store.dispatch('courses_pickContentShare', body)

                getContent()
                
            } catch (err) {
                console.log(err)
                store.dispatch('notifications_create', { text: 'Ha ocurrido un error seleccionando el contenido.' })
            } finally {
                modalPreview.value = undefined
                confirmModal.value = false
                selectingContent.value = false
            }
        }

        async function copyToClipboard(text){
            try
            {
                await navigator.clipboard.writeText(text)
                store.dispatch('notifications_create', {text: 'El enlace fue copiado'})
            }
            catch {
                store.dispatch('notifications_create', {text: 'El enlace no pudo copiarse'})
            }
        }

        async function downloadExcel(){
            downloadingExcel.value = true;
            try {
                await store.dispatch('courses_tutorReportExcelFinalPractice',{courseId: route.params.courseId, fileName: 'Reporte_trip'});
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', {text: 'Error al intentar descargar archivo'})
            } finally{
                downloadingExcel.value = false;
            }
        }



        function removeCustomText(data) {
            return data.replace(/\[BEGIN_OWN\].*?\[END_OWN_BOTON\]/gs, '');
        }


        async function getContent(){
            try {
                let req = await store.dispatch('courses_finalPractice',route.params.courseId);
                moduleData.value = req.data[0];
                if(moduleData.value.contents.length){
                    let $fragment = document.createDocumentFragment();
                    moduleData.value.contents.forEach((content, idx) => {
                        if(renderContentTypes.includes(content.type.toUpperCase())){
                            try {
                                content.data = JSON.parse(content.data);
                                // Eliminar texto personalizado
                                if (content.data.Data) {
                                    content.data.Data = removeCustomText(content.data.Data);
                                }
                                if (content.data.Preview) {
                                    content.data.Preview = content.data.Preview.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
                                } else if (content.data.Data) {
                                    content.data.Data = content.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
                                }
                            } catch (e){
                                console.log("Error id " + content.id + e);
                            }
                        }
                        if(content.type.toUpperCase() == 'HTML'){
                            let data = document.createElement('div');
                            data.classList.add(`content-${content.orderNumber}`);
                            data.innerHTML = content.data.Data;
                            $fragment.appendChild(data);
                        }
                        else if(content.type.toUpperCase() == 'ATTACH'){
                            let preview = document.createElement('div');
                            preview.classList.add('attach-preview')
                            preview.innerHTML = content.data.Preview;
                            let $links = preview.getElementsByTagName('a');
                            for(let link of $links){
                                link.addEventListener('click', (e)=>{
                                    e.preventDefault();
                                    let url = `/course/${route.params.courseId}/module/${route.params.moduleId}/activity/attach/${content.id}`;
                                    // si es curso DOCENTE se le pide la cantidad de estudiantes luego de entregar la reflexión
                                    if (moduleData.value.targetType === 0) {
                                        url += '?sQty=true';
                                    }
                                    router.push(url);
                                });
                                let href = `/course/${route.params.courseId}/module/${route.params.moduleId}/activity/attach/${content.id}`;
                                // si es curso DOCENTE se le pide la cantidad de estudiantes luego de entregar la reflexión
                                if (moduleData.value.targetType === 0) {
                                    href += '?sQty=true';
                                }
                                link.setAttribute('href', href);
                            }
                            $fragment.appendChild(preview);
                        }
                        else if(content.type.toUpperCase() == 'FORUM'){
                            let preview = document.createElement('div');
                            preview.classList.add('foro-preview')
                            preview.innerHTML = content.data.Preview;
                            let $links = preview.getElementsByTagName('a');
                            for(let link of $links){
                                link.addEventListener('click', (e)=>{
                                  e.preventDefault();
                                  router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${content.id}`)
                                })
                                link.setAttribute('href', `/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${content.id}`)
                            }
                            $fragment.appendChild(preview);
                        } else if (content.type.toUpperCase() == 'TRIP'){
                            let data = document.createElement('div');
                            data.classList.add(`content-${content.orderNumber}`);
                            let ownLink = content.data.OwnLink;
                            let linkToShare = content.data.LinkToShare;
                            let contentHTML = content.data.Data;
                            // ownLink
                            //     ? contentHTML = contentHTML.replace("[[<TRIP_DOCENTE_URL>]]",ownLink)
                            //     : contentHTML = contentHTML.replace("[[<TRIP_DOCENTE_URL>]]",'')
                            // linkToShare
                            //     ? contentHTML = contentHTML.replace("[[<TRIP_ALUMNODOCENTE_URL>]]",linkToShare)
                            //     : contentHTML = contentHTML.replace("[[<TRIP_ALUMNODOCENTE_URL>]]",'Enlace no disponible')

                            data.innerHTML = contentHTML;
                            let copyLinkBtn = data.querySelector('#shareTRIPBtn');
                            if (copyLinkBtn) {
                                // const linkView = document.createElement('a');
                                // a href linkToShare
                                // create element with href linkToShare
                                const linkView = document.createElement('a');
                                // linkView.setAttribute('href', 'http://' + linkToShare);
                                // if linkToShare doesn't contain href, add it
                                if (linkToShare == undefined || linkToShare == null) {
                                    // print "-" if linkToShare is undefined
                                    linkToShare = '-';
                                    linkView.innerHTML = linkToShare;
                                    copyLinkBtn.parentNode.insertBefore(linkView, copyLinkBtn);
                                    copyLinkBtn.style.pointerEvents = 'none';
                                    copyLinkBtn.style.opacity = '0.5';
                                } else {
                                    let linkToShareHref = linkToShare;
                                    if (linkToShareHref != null && !linkToShareHref.includes('http')) {
                                        linkToShareHref = 'http://' + linkToShareHref;
                                    }                                
                                    linkView.setAttribute('href', linkToShareHref);
                                    linkView.setAttribute('target', '_blank');
                                    linkView.innerHTML = linkToShare;
                                    copyLinkBtn.parentNode.insertBefore(linkView, copyLinkBtn);
                                }
                            }
                            if(linkToShare){
                                copyLinkBtn.innerText = 'Copiar link'
                                copyLinkBtn.addEventListener('click', async () => { await copyToClipboard(linkToShare) } );
                            }else{
                                copyLinkBtn.style.display = 'none'
                            }
                            if(!ownLink){
                                let ownLinkBtn = data.querySelector('#ownTRIPBtn');
                                if(ownLinkBtn)
                                {
                                    ownLinkBtn.addEventListener('click', e => e.preventDefault())
                                    ownLinkBtn.style.opacity = '0.5'
                                    ownLinkBtn.style.cursor = 'default'
                                }
                            }
                            $fragment.appendChild(data);
                        } else if (content.type.toUpperCase() == 'CONTENTSHARE') {
                            const div = document.createElement('div');

                            // Iterar sobre los datos de contenido compartido
                            // Crear una sección para el contenido compartido
                            const section = document.createElement('section');
                            section.className = 'finalPractice';
                            section.id = `contentshare--${content.id}`

                            // Crear la segunda sección de datos
                            const welcomeData2 = document.createElement('div');
                            welcomeData2.className = 'finalPractice__data';
                            const welcomeData2Span = document.createElement('span');
                            const welcomeData2Strong = document.createElement('strong');
                            welcomeData2Strong.textContent = 'Aprender haciendo | ';
                            welcomeData2Span.appendChild(welcomeData2Strong);

                            let subtitle = 'Dinámicas para realizar en clase';
                            let description = 'Primero, selecciona entre las siguientes actividades cuál deseas realizar en clase con tus estudiantes.';
                            if (content.data.Subcontents.length == 1) {
                                subtitle = 'Dinámica para realizar en clase';
                                description = 'Haz clic para conocer la propuesta de la actividad para realizar con tus estudiantes.';
                            }

                            welcomeData2Span.appendChild(document.createTextNode(subtitle));
                            welcomeData2.appendChild(welcomeData2Span);
                            const welcomeData2P = document.createElement('p');
                            welcomeData2P.textContent = description;
                            welcomeData2.appendChild(welcomeData2P);

                            // Agregar las dos secciones de datos a la sección principal
                            section.appendChild(welcomeData2);

                            // Crear la sección de opciones
                            const optionsSection = document.createElement('section');
                            optionsSection.className = 'finalPractice__options';

                            // Iterar sobre las opciones
                            content.data.Subcontents.forEach((option) => {
                                const optionDiv = document.createElement('div');
                                optionDiv.className = `finalPractice__card${(content.data.SelectedOption && content.data.SelectedOption !== option.Identifier) ? '--disabled' : ''}`;
                                if (!(content.data.SelectedOption && content.data.SelectedOption !== option.Identifier)) {
                                    optionDiv.addEventListener('click', () => {
                                        modalPreview.value = option;
                                        modalPreview.value.contentId = content.id;
                                        modalPreview.value.idx = idx;
                                        modalPreview.value.isSelected = !!content.data.SelectedOption
                                    });
                                }

                                const optionImg = document.createElement('img');
                                optionImg.src = option.ImagePreview;
                                optionDiv.id = `contentshare--${content.id}--${option.Identifier}`
                                optionDiv.appendChild(optionImg);

                                optionsSection.appendChild(optionDiv);
                            });

                            section.appendChild(optionsSection);
                            let divLink = undefined;

                            if (content.data.LinkToShare) {
                                divLink = document.createElement('div');
                                divLink.classList.add('finalPractice__link');
                                divLink.innerHTML = '<span>Enlace para compartir:</span>';

                                // Only create 'a' tag if data.ShortLink has a value
                                if (content.data.ShortLink) {
                                        let shortLink = content.data.ShortLink;
                                        let displayLink = shortLink;

                                        // Ensure the href starts with 'http://' or 'https://'
                                        if (!shortLink.startsWith('http://') && !shortLink.startsWith('https://')) {
                                            shortLink = 'https://' + shortLink;
                                        }

                                        const linkElement = document.createElement('a');
                                        linkElement.href = shortLink;
                                        linkElement.textContent = displayLink;
                                        linkElement.target = '_blank';
                                        linkElement.classList.add('finalPractice__linkURL');
                                        divLink.appendChild(linkElement);
                                    }

                                    // Create the button to copy the link
                                    const button = document.createElement('button');
                                    button.classList.add('finalPractice__linkButton');
                                    button.innerText = 'Copiar link';
                                    button.addEventListener('click', async () => {
                                        // Copy ShortLink if available, else LinkToShare
                                        let linkToCopy = content.data.ShortLink || content.data.LinkToShare;
                                        if (typeof linkToCopy === 'string' && linkToCopy.trim() !== '') {
                                            try {
                                                await navigator.clipboard.writeText(linkToCopy);
                                                store.dispatch('notifications_create', { text: 'Link copiado al portapapeles.' });
                                            } catch (err) {
                                                console.error(err);
                                                store.dispatch('notifications_create', { text: 'Ha ocurrido un error copiando el link.' });
                                            }
                                        } else {
                                            console.error('El valor del enlace no es una cadena de texto válida.');
                                            store.dispatch('notifications_create', { text: 'Ha ocurrido un error copiando el link.' });
                                        }
                                    });
                                    divLink.appendChild(button);

                                    section.appendChild(divLink);

                            }
                            // Agregar la sección principal al div principal
                            div.appendChild(section);

                            $fragment.appendChild(div);
                        }
                    });
                    container.innerHTML = '';
                    container.appendChild($fragment);
                }else{
                    container.innerHTML = '<span>No hay contenidos para mostrar</span>'
                }
                moduleDataLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', {text: 'Error al cargar contenido'})
            }
        }

        onMounted(()=>{
            container = document.querySelector('.content-container');
            getContent()   
        })

        return{
            route,
            router,
            moduleData,
            moduleDataLoaded,
            user,
            downloadExcel,
            downloadingExcel,
            showEmptyState,
            modalPreview,
            modalView,
            confirmModal,
            contentShare,
            selectOption,
            selectingContent
        }

    },
}
</script>

<style lang="scss">
@import '@/styles/main.scss';

.final-practice{
    .back-route{
        width: fit-content;
        display: flex;
        align-items: center;
        gap: 1px;
        font-weight: 600;
        font-size: 12px;
        color: $green;
        cursor: pointer;
        .material-icons{
            font-size: 17px;
        }
    }
    .content-container{
        font-size: 18px !important;
        *{
            font-size: 18px !important;
        }
    }
    h2{
        font-weight: 700;
        font-size: 22px;
        padding: 14px 0 6px 0;
        margin-bottom: 4px;
        color: $black;
        border-bottom: 1px solid rgba(125, 125, 125, 0.5);
    }
    
    #shareTRIPBtn{
        margin: 0 6px;
        padding: 2px 12px;
        background: $green;
        font-size: 14px;
        color: #fff;
        border-radius: 12px;
    }

    
    .tutor-download-excel{
        margin-top: 12px;
        margin-bottom: -12px;
        padding: 12px;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        gap: 16px;
        background-color: #F5F5F5;
        position: sticky;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background: #fff;
        border-top: 2px solid #eee;
        z-index: 99;
        button{
            font-size: 16px;
            font-weight: 600;
            background: #009696;
            color: #fff;
            padding: 11px 25px;
            border-radius: 99px;
            &:disabled{
                opacity: .6;
                cursor: default;
            }
       }
    }

}

.finalPractice{
    display: flex;
    flex-direction: column;
    gap: 36px;
    &__welcome{
        display: flex;
        flex-direction: column;
        gap: 18px;
    }
    &__data{
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 16px;
        font-weight: 400;
        span{
            display: flex;
            align-items: center;
            gap: 8px;
            img{
                width: 48px;
                height: 48px;
            }
            strong{
                font-weight: 600;
            }   
        }
    }
    &__link{
        display: flex;
        align-items: center;
        gap: 24px;
        font-size: 16px;
        font-weight: 700;
    }
    &__linkButton{
        padding: 8px 29px;   
        color: $green;
        border: 1px solid $green;
        text-align: center;
        border-radius: 44px;
        font-weight: 600;
        font-size: 14px;
    }
    &__options{
        display: flex;
        align-items: center;
        gap: 24px;
        width: 100%;
    }
    &__card{
        border-radius: 10px;
        cursor: pointer;
        padding: 4px;
        width: 25%;
        height: 120px;
        transition: transform .2s ease;
        &:hover{
            transform: scale(1.03);
        }
        img{
            max-width: 285px;
            max-height: 120px;
            width: 200%;
            height: 200%;
            border-radius: 10px;
            object-fit: cover;
        }
        &--disabled{
            @extend .finalPractice__card;
            cursor: default;
            opacity: .6;
            &:hover{
                transform: none;
            }
        }
    }
    &__button{
        height: 45px;
        color: #fff;
        background-color: $green;
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 44px;
        width: fit-content;
        padding: 0 42px;
        .material-icons-outlined{
            font-size: 18px;
        }
    }
    &__modal{
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        padding: 0px 16px 16px;
        position: relative;
        &_iframe{

            &__disclaimer {
                font-size: 14px;
                margin-bottom: 16px;
            }
        }
        &_views{
            display: flex;
            align-items: center;
            width: 100%;
            border-bottom: 1px solid #e6e6e6;
            gap: 12px;
        }
        &_view{
            padding: 12px 8px;
            padding-bottom: 16px;
            font-size: 15px;
            font-weight: 500;
            color: #212121;
            &--active{
                padding: 12px 8px;
                font-size: 15px;
                font-weight: 500;
                color: $green;
                border-bottom: 5px solid $green;
                
            }
        }
        &__buttons{
            margin: 0 auto;
            display: flex;
            width: 100%;
            align-items: center;
            gap: 24px;
            justify-content: center;
        }
        &_button:first-child{
            color: $green;
            font-size: 16px;
            font-weight: 600;
        }
        &_button:last-child{
            font-size: 16px;
            font-weight: 600;
            background-color: $green;
            color: #fff;
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px 28px;
            border-radius: 44px;
            .material-icons-outlined{
                font-size: 18px;
            }
        }
    }
}

.confirmModal{
    width: 100%;
    padding: 34px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    text-align: center;
    &__title{
        font-weight: 600;
        font-size: 18px;
        strong{
            font-weight: 700;
            font-style: italic;
            color: $green;
        }
    }
    &__description{
        font-weight: 400;
        font-size: 18px;
    }
    &__buttons{
        display: flex;
        align-items: center;
        gap: 18px;
        width: 100%;
        justify-content: center;
        margin-top: 18px;
    }
    &__cancel{
        font-weight: 600;
        font-size: 16px;
        color: #212121;
    }
    &__confirm{
        color: #fff;
        background-color: $green;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
        padding: 10px 29px;
        border-radius: 44px;
        font-size: 16px;
    }
}
.finish-button__button {
    font-weight: 600;
    background-color: var(--green);
    color: #fff;
    border-radius: 99999px;
    padding: 12px 28px;
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 17px;
}
</style>